import * as React from 'react';
import { InjectedAppProps, withApp } from 'src/_context/App';
import withStyles, { StyledComponentProps } from 'react-jss'
import { NavLink, RouteComponentProps, withRouter } from 'react-router-dom';
import * as classNames from 'classnames';
import stylesheet, { directions, fontSize, linkGutter } from 'src/Constants/stylesheet';
import { Language } from 'src/_helpers/Languages';
import fonts from 'src/Constants/fonts';
import responsive from 'src/Constants/responsive';
import spacing from 'src/Constants/spacing';

type MenuProps = React.HTMLAttributes<HTMLElement> & {
    isMobile: boolean;
};

const linkLangFontSize = {
    'Mobile': `${12 / fontSize.Mobile}rem`,
    'AfterMobile': `${17 / fontSize.Desktop}rem`
};
const linkLangGutter = {
    'Mobile': `${10 / fontSize.Mobile}rem`,
    'AfterMobile': `${12 / fontSize.Desktop}rem`
};

const styles = {
    menu: {
        position: 'relative',
        zIndex: 99,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        ...stylesheet.MarginGutter(1, directions.sides)
    },
    menuHeight: {
        [responsive.Mobile]: {
            height: spacing.NavHeight.Mobile
        },
        [responsive.AfterMobile]: {
            height: spacing.NavHeight.Desktop
        }
    },
    nav: {},
    menuLink: {
        fontSize: '1rem',
        whiteSpace: 'nowrap',
        [responsive.Mobile]: {
            marginRight: linkGutter.Mobile,
        },
        [responsive.AfterMobile]: {
            marginRight: linkGutter.AfterMobile,
        }
    },
    langNav: {},
    langLink: {
        [responsive.Mobile]: {
            fontSize: linkLangFontSize.Mobile,
            marginRight: linkLangGutter.Mobile
        },
        [responsive.AfterMobile]: {
            fontSize: linkLangFontSize.AfterMobile,
            marginRight: linkLangGutter.AfterMobile
        },

        '&:last-child': {
            marginRight: 0
        }
    },
    active: {
        ...fonts.ExcelsiorLTItalic
    }
}
type Props = MenuProps &
    InjectedAppProps &
    RouteComponentProps &
    StyledComponentProps<keyof typeof styles>;

export class Menu extends React.PureComponent<Props> {
    constructor(props: Props) {
        super(props);
    }
    render() {
        const { classes, isMobile, appContext: { app }, location: { pathname }, ...rest } = this.props;
        const home = pathname === "/en" || pathname === "/fr";
        
        return (
            <div className={classNames(classes!.menu, classes!.menuHeight, rest.className)}>
                <nav className={classes!.nav}>
                    {app && app.Menus.map(menu =>
                        <NavLink
                            key={menu.UID}
                            to={`/${Language}/${menu.UID}`}
                            className={
                                classNames(
                                    classes!.menuLink, 
                                    home && 
                                    (menu.UID === "pieces" ||  menu.UID === "artworks") ? classes!.active : '' )}
                            activeClassName={classes!.active}
                        >
                            {isMobile ? menu.ShortTitle : menu.Title}
                        </NavLink>
                    )}
                </nav>
                <div className={classes!.langNav}>
                    <a
                        className={classNames(classes!.langLink, Language === "fr" ? classes!.active : null)}
                        href={`?switch-lang=fr`}
                    >
                        FR
                    </a>
                    <a
                        className={classNames(classes!.langLink, Language === "en" ? classes!.active : null)}
                        href={`?switch-lang=en`}
                    >
                        EN
                    </a>
                </div>
            </div >);
    }
}

export default withRouter(withApp(withStyles(styles)(Menu)));


// WEBPACK FOOTER //
// ./src/Components/Menu.tsx